module.exports = __webpack_public_path__ + "static/img/step_4-button.5806fec6.png";